import React, { Component } from "react";
import { connect } from "react-redux";
import Intercom from "react-intercom";

export class InterCom extends Component {
  render() {
    const { appUser } = this.props;

    const user = {
      user_id: appUser.id,
      email: appUser.email,
      name: appUser.name,
    };
    window.intercomSettings = {
      vertical_padding: 110,
    };
    return (
      <div className="app">
        <Intercom appID="xndefqnl" vertical_padding="110" {...user} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InterCom);
